/**
 * Check for touch events (detects IE Tablet with Windows RT)
 * This function return true in the case is a:
 * - pc touchscreen enabled in mode not mobile
 * @return {Boolean} Is the website displayed on a touch enabled screen?
 */
export const isTouch = () => 'ontouchstart' in window;

/**
 * See if it is one of microsoft f***** up tablet/laptop anomalies.
 * @return {Boolean} [description]
 */
export const isWindowsTouch = () => {
	if (navigator.msMaxTouchPoints !== undefined) {
		if (navigator.msMaxTouchPoints === 0) {
			return false;
		}
	}

	return 'onmouseenter' in window && 'msMaxTouchPoints' in navigator;
};

export const isIE = () => {
	let msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
	if (isNaN(msie)) {
	  msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
	}
	return msie;
};

/**
 * Get the correctly prefixed transitionend event string
 * @return {string} Transitionend event name
 */
export const getTransitionEndString = () => {
	let i,
	    undefined,
	    el = document.createElement('div'),
	    transitions = {
	        transition: 'transitionend',
	        OTransition: 'otransitionend',  // oTransitionEnd in very old Opera
	        MozTransition: 'transitionend',
	        WebkitTransition: 'webkitTransitionEnd',
	    };

	for (i in transitions) {
	    if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
	        return transitions[i];
	    }
	}

	// Return a fallback for browsers who don't know transitions
	return 'transitionEndFallback';
};

/**
 * Check if window width is below mobile threshhold
 * @return {Boolean} True if mobile, false if above or equal 768
 */
export const isMobileView = function(){	
	return window.innerWidth < 992;	
}; 

let device = 'large';			// 1920 <=      px
const desktop = 1920;				// 1200 -  1919 px
const laptop = 1200; 				//  992 -  1199 px
const tablet = 992;				//  768 -   991 px
const mobile = 768;				//    0 -   767 px

/**
 * Get a string representing current viewport width
 * @return {string} Viewport width category
 */
export const getViewport = function () {
	let width = window.innerWidth;

	if (width < desktop) device = 'desktop';
	if (width < laptop) device = 'laptop';
	if (width < tablet) device = 'tablet';
	if (width < mobile) device = 'mobile';

	return device;
};



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/core.js